import { api } from './client';
import type { SyncResponse, UserResponse } from '@/types/api';

export async function sync(): Promise<SyncResponse> {
  return api.post('/api/auth/sync');
}

export async function me(): Promise<UserResponse> {
  return api.get('/api/auth/me');
}
